module.exports = __webpack_public_path__ + "static/media/coin.7d72d12f.svg";